export const nodeStyles = {
  size: 20,
};
